import { useTranslations } from 'next-intl';
import CasesEn from '@/app/assets/imgs/cases_en.png';
import CasesZh from '@/app/assets/imgs/cases_zh.png';
import ViduClawIcon from '@/app/assets/imgs/vidu_claw_icon.png';
import { SITE } from '@/app/constants';
import { ExploreTabRouterEnum, HomeTabRouterEnum } from '@/app/types';
import { useLocale } from '@/i18n/routing';

export type TabItem = {
  key: HomeTabRouterEnum | ExploreTabRouterEnum;
  label: string | React.ReactNode;
  icon?: React.ReactNode;
};

export const useExploreTabs = (isExplore?: boolean) => {
  const t = useTranslations();
  const locale = useLocale();
  const tabs: TabItem[] = [];

  if (!isExplore) {
    tabs.push({
      key: HomeTabRouterEnum.Recommend,
      label: t('homeTab.recommended'),
    });
  }

  if (isExplore) {
    tabs.push({
      key: ExploreTabRouterEnum.Inspiration,
      label: t('homeTab.mediaAsset'),
    });
  }

  tabs.push({
    key: ExploreTabRouterEnum.Cases,
    label:
      locale === 'en' ? (
        <img src={CasesEn.src} alt="cases" className="h-4" key="cases" />
      ) : locale === 'zh' ? (
        <img src={CasesZh.src} alt="cases" className="h-4" key="cases" />
      ) : (
        t('homeTab.cases')
      ),
    icon: <img src={ViduClawIcon.src} alt="vidu_claw_icon" className="mb-1 h-[14px]" key="vidu_claw_icon" />,
  });

  tabs.push({
    key: ExploreTabRouterEnum.PostReferences,
    label: t('homeTab.sharedReferences'),
  });

  // china 首页只保留 推荐/主体，短片/教程/活动 收入推荐的二级筛选 tab
  if (isExplore || SITE !== 'china') {
    tabs.push(
      {
        key: ExploreTabRouterEnum.ShortFilm,
        label: t('homeTab.shortFilm'),
      },
      {
        key: ExploreTabRouterEnum.Tutorial,
        label: t('homeTab.tutorial'),
      },
      {
        key: HomeTabRouterEnum.Activity,
        label: t('homeTab.activity'),
      },
    );
  }

  return tabs;
};
